import "./style/horizontal-scroller.scss"

import React from "react"
import classNames from "classnames"

interface HorizontalScrollerElementProps {
    single?: boolean
    small?: boolean
    medium?: boolean
    children?: React.ReactNode
}

const HorizontalScrollerElement = ({
    children,
    single,
    small,
    medium,
}: HorizontalScrollerElementProps) => {
    return (
        <li
            className={classNames("horizontal-scroller__element ", {
                "horizontal-scroller__element--single": single,
                "horizontal-scroller__element--small": small,
                "horizontal-scroller__element--medium": medium,
            })}
        >
            {children}
        </li>
    )
}

interface HorizontalScrollerProps {
    singleItemFillter?: boolean
    children?: any
    medium?: boolean
    small?: boolean
    height: number | "auto"
    edgeGutter?: number
}

const HorizontalScroller = ({
    singleItemFillter,
    children,
    medium,
    small,
    height,
    edgeGutter,
}: HorizontalScrollerProps) => {
    const elements = React.Children.map(children, (i, index) => {
        return (
            <HorizontalScrollerElement
                single={singleItemFillter && children.length === 1}
                small={small}
                medium={medium}
                key={index}
            >
                {React.cloneElement(i)}
            </HorizontalScrollerElement>
        )
    })

    if (!children.length) {
        //return null
    }

    return (
        <div
            className={classNames("horizontal-scroller", {
                "horizontal-scroller--dynamic-height": height === "auto",
            })}
            style={
                {
                    height,
                    "--horizontal-scroller-edge-gutter":
                        edgeGutter !== undefined ? `${edgeGutter}px` : undefined,
                } as React.CSSProperties
            }
            onScroll={e => e.stopPropagation()}
        >
            <ul className="horizontal-scroller__wrapper">
                {children && children.length ? elements : null}
            </ul>
        </div>
    )
}

export default HorizontalScroller
